import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SupplierInboxJobsService } from 'src/app/services/supplier-inbox-jobs.service';
import { SelectItem } from 'primeng';

@Component({
  selector: 'allocate-depot-dialog',
  templateUrl: './allocate-depot-dialog.component.html',
  styleUrls: ['./allocate-depot-dialog.component.scss'],
})
export class AllocateDepotDialogComponent {
  @Input() visible: boolean = false;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() depotAllocated: EventEmitter<number> = new EventEmitter<number>();

  @Input() jobId: number;

  supplierDepots: SelectItem[] = [];

  selectedDepotId: number;

  loading: boolean;

  constructor(private supplierInboxJobsService: SupplierInboxJobsService) {}

  async onShow() {
    this.loading = true;

    const depots = (await this.supplierInboxJobsService.getSupplierUserDepots()) || [];

    if (depots.length === 1) {
      this.selectedDepotId = depots[0].id;
      void this.allocateDepot();
      this.visibleChange.emit(false);
      return;
    }

    this.supplierDepots = depots.map((d) => ({ label: d.name, value: d.id }));

    this.loading = false;
  }

  async allocateDepot() {
    await this.supplierInboxJobsService.allocateDepot(this.jobId, this.selectedDepotId);

    this.depotAllocated.emit(this.selectedDepotId);

    this.visibleChange.emit(false);
  }
}
